import { __ } from '@/hub-shared/utils/i18n';
import type { ReactNode } from 'react';

type WizardShellProps = {
  sidebar: ReactNode;
  canGoBack: boolean;
  canGoNext: boolean;
  nextLabel: string;
  primaryAriaLabel?: string;
  onBack: () => void;
  onNext: () => void;
  onCancel: () => void;
  onReset: () => void;
  children: ReactNode;
};

export const WizardShell = ({
  sidebar,
  canGoBack,
  canGoNext,
  nextLabel,
  primaryAriaLabel,
  onBack,
  onNext,
  onCancel,
  onReset,
  children,
}: WizardShellProps) => (
  <div className="import-wizard container-style no-padding">
    <div className="import-wizard__layout">
      <aside className="import-wizard__sidebar" aria-label={__('Connecteurs')}>
        {sidebar}
      </aside>

      <div className="import-wizard__content">{children}</div>
    </div>
    <div className="form-actions">
      <button type="button" className="btn-secondary" onClick={onCancel}>
        {__('Annuler')}
      </button>
      <button type="button" className="btn-secondary" onClick={onReset}>
        {__('Réinitialiser')}
      </button>
      <button type="button" className="btn-secondary" onClick={onBack} disabled={!canGoBack}>
        {__('Précédent')}
      </button>
      <button
        type="button"
        className="btn-primary"
        aria-label={primaryAriaLabel ?? __('Suivant (wizard)')}
        onClick={onNext}
        disabled={!canGoNext}
      >
        {nextLabel}
      </button>
    </div>
  </div>
);
